import { getFunctions, httpsCallable } from 'firebase/functions';

// Ziraat Bank 3D Secure payment integration service
// This service triggers NestPay 3D Pay Hosting where card entry happens on the bank page

interface Initiate3DPaymentRequest {
  paymentLinkId: string;
  linkId: string; // The friendly link ID (e.g., ALX-2511211207-A7K9M) for callback URLs
  amount: number;
  currency: string;
  // Card fields (storetype=3d_pay - card collected in our form)
  cardNumber: string;
  cardExpiry: string; // MMYY format
  cardCVV: string;
  cardHolder: string;
}

interface Initiate3DPaymentResponse {
  htmlContent: string; // 3D form HTML to submit
  orderId: string;
}

/**
 * Initiates 3D Secure payment via Firebase Cloud Function
 * @param data Payment data including card details
 * @returns 3D form HTML and order ID
 * @throws Error if initiation fails
 */
export const initiate3DPayment = async (
  data: Initiate3DPaymentRequest
): Promise<Initiate3DPaymentResponse> => {
  const functions = getFunctions();
  const initiatePayment = httpsCallable<
    Initiate3DPaymentRequest,
    Initiate3DPaymentResponse
  >(functions, 'initiate3DPayment');

  try {
    const result = await initiatePayment(data);
    return result.data;
  } catch (error: any) {
    console.error('3D payment initiation failed:', error);

    // Provide user-friendly error messages
    if (error.code === 'functions/not-found') {
      throw new Error('Payment service not available. Please contact support.');
    }

    if (error.code === 'functions/unauthenticated') {
      throw new Error('Authentication required. Please refresh the page and try again.');
    }

    throw new Error(error.message || 'Failed to initiate payment');
  }
};
